import { useQueryClient } from "@tanstack/react-query";
import { FinancialProposal } from "../../types";
import { CreateProposalDto } from "../../dtos/rental-financial-proposal";
import { createProposal } from "../../api/rental-financial-proposal";
import { AxiosResponse } from "axios";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

export function useCreateProposal() {
  const queryClient = useQueryClient();

  const mutation = useDomainMutation<
    AxiosResponse<FinancialProposal>,
    { response?: { data?: { message?: string } } },
    { data: CreateProposalDto }
  >({
    mutationFn: ({ data }: { data: CreateProposalDto }) => {
      return createProposal(data);
    },

    onSuccess: (_, { data }) => {
      queryClient.invalidateQueries({ queryKey: ["financial-proposals"] });
      queryClient.invalidateQueries({ queryKey: ["track", data.trackUid] });
    },
  });

  return mutation;
}
